export function getRecaptchaSiteKeyFromDOM(): string | null {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="recaptcha-site-key"]')?.content;
    if (meta) return meta;
    const s = document.querySelector<HTMLScriptElement>('script[src*="recaptcha/api.js?render="]')?.src;
    const m = s?.match(/[?&]render=([^&]+)/);
    if (m?.[1]) return decodeURIComponent(m[1]);

    if (typeof window !== "undefined" && window.__RECAPTCHA_SITE_KEY) {
        return String(window.__RECAPTCHA_SITE_KEY);
    }
    return null;
}